module.exports = __webpack_public_path__ + "static/images/tutorial-4.0ccf20a65e691f51a36623b498e051fe.svg";